export default function ResultsReports({selectedYear}) {
  return (
    <>
      <div className="row">
        <h3 className="m-3">Результаты</h3>
      </div>
      <div className="m-3 p-4 lk-start-page">
        <p className="mb-0">
          Здесь будут отображаться отчеты о результатах исследований по всем завершенным заданиям за {selectedYear} год.
        </p>
      </div>
    </>
  );
}
